/**
 * @generated SignedSource<<6410b7301090ca08118cdf97c273e44b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatsViewsOrderBy = "NATURAL" | "ID_ASC" | "ID_DESC" | "CREATE_TIME_ASC" | "CREATE_TIME_DESC" | "END_TIME_ASC" | "END_TIME_DESC" | "CREATE_TIME_FORMATTED_ASC" | "CREATE_TIME_FORMATTED_DESC" | "END_TIME_FORMATTED_ASC" | "END_TIME_FORMATTED_DESC" | "ACCOUNT_ID_ASC" | "ACCOUNT_ID_DESC" | "FIRST_NAME_ASC" | "FIRST_NAME_DESC" | "LAST_NAME_ASC" | "LAST_NAME_DESC" | "PRIMARY_KEY_ASC" | "PRIMARY_KEY_DESC" | "%future added value";
export type ChatsListQuery_chatsQuery$variables = {
  first?: number | null;
  after?: any | null;
  orderBy?: ReadonlyArray<ChatsViewsOrderBy> | null;
  offset?: number | null;
};
export type ChatsListQuery_chatsQuery$data = {
  readonly id: string;
  readonly allChatsViews: {
    readonly totalCount: number;
    readonly pageInfo: {
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: any | null;
      readonly endCursor: any | null;
    };
    readonly edges: ReadonlyArray<{
      readonly cursor: any | null;
      readonly node: {
        readonly id: string;
        readonly rowId: any;
        readonly " $fragmentSpreads": FragmentRefs<"ChatRow">;
      } | null;
    }>;
  } | null;
};
export type ChatsListQuery_chatsQuery = {
  variables: ChatsListQuery_chatsQuery$variables;
  response: ChatsListQuery_chatsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatsListQuery_chatsQuery",
    "selections": [
      (v4/*: any*/),
      {
        "alias": "allChatsViews",
        "args": (v5/*: any*/),
        "concreteType": "ChatsViewsConnection",
        "kind": "LinkedField",
        "name": "__ChatsListQuery_allChatsViews_connection",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatsViewsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatsView",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ChatRow"
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ChatsListQuery_chatsQuery",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "ChatsViewsConnection",
        "kind": "LinkedField",
        "name": "allChatsViews",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatsViewsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatsView",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createTimeFormatted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endTimeFormatted",
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "filters": [
          "first",
          "after",
          "orderBy",
          "offset"
        ],
        "handle": "connection",
        "key": "ChatsListQuery_allChatsViews",
        "kind": "LinkedHandle",
        "name": "allChatsViews"
      }
    ]
  },
  "params": {
    "cacheID": "a4663f61572458940eaa488761353ebe",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "allChatsViews"
          ]
        }
      ]
    },
    "name": "ChatsListQuery_chatsQuery",
    "operationKind": "query",
    "text": "query ChatsListQuery_chatsQuery(\n  $first: Int\n  $after: Cursor\n  $orderBy: [ChatsViewsOrderBy!]\n  $offset: Int\n) {\n  id\n  allChatsViews(first: $first, after: $after, orderBy: $orderBy, offset: $offset) {\n    totalCount\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        rowId\n        ...ChatRow\n        __typename\n      }\n    }\n  }\n}\n\nfragment ChatRow on ChatsView {\n  id\n  accountId\n  rowId\n  firstName\n  lastName\n  createTimeFormatted\n  endTimeFormatted\n}\n"
  }
};
})();

(node as any).hash = "f8cba6d12910674d24840d1461a57007";

export default node;
